/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef } from "react";
import "./CategoryBanner.scss";
import { Avatar, Skeleton } from "@mui/material";
import { useSelector } from "react-redux";
import { RootState } from "../../store/reducers";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { get_lang } from "../../helper/getLang";
import { useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import { actionCreators } from "../../store";
import Navbar from "../Navbar/Navbar";

const CategoryBanner = (props: any) => {
  const { handleGoBack } = props;

  const dispatch = useDispatch();
  const { langValueState } = bindActionCreators(actionCreators, dispatch);
  const navigate = useNavigate();
  const state = useSelector((state: RootState) => state.appReducer);
  const { langValue } = state;
  const apiState = useSelector((state: RootState) => state.apiReducer);
  const { storeId, storeInfo } = apiState;
  const { bookingInfo } = storeInfo || {};
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const [bId, setBId] = useState(searchParams.get("bId"));
  const { slug } = useParams();

  const { bookingDetails } = apiState;
  const [isLoading, setIsLoading] = useState(true);
  const [caterogryBanner, setCaterogryBanner]: any = useState(null);
  const [scroll, setScroll]: any = useState(false);
  const [expanded, setExpanded] = useState(false); // State for "Show More"
  const [bannerHeight, setBannerHeight] = useState("35vh"); // Dynamic banner height
  const descriptionRef = useRef<HTMLHeadingElement>(null); // Ref for h3 element

  useEffect(() => {
    if (bId) {
      let findCategory = bookingDetails.find(
        (item: any) => item?.id == Number(bId)
      );
      if (findCategory) {
        setCaterogryBanner(findCategory);
      } else {
        if (apiState.storeId) {
        } else {
          navigate(`/${slug}`);
        }
      }
    }
  }, [bId]);

  useEffect(() => {
    setBId(searchParams.get("bId"));
  }, [searchParams]);

  useEffect(() => {
    if (caterogryBanner) {
      setIsLoading(false);
    }
  }, [caterogryBanner]);

  // Calculate banner height based on h3 element height when expanded
  useEffect(() => {
    if (!caterogryBanner) {
      setBannerHeight("35vh");
      return;
    }

    // Use setTimeout to ensure DOM has updated after render
    const timer = setTimeout(() => {
      if (descriptionRef.current) {
        // Get the actual height of the h3 element
        const h3Height = descriptionRef.current.scrollHeight;
        // Base banner height (35vh) + h3 height + some padding
        // Convert vh to pixels for calculation (approximate: 1vh ≈ window.innerHeight / 100)
        const baseHeightVh = 20;
        const baseHeightPx = (window.innerHeight * baseHeightVh) / 100;
        const totalHeightPx = baseHeightPx + h3Height ; // 80px for padding/margins/button
        const totalHeightVh = (totalHeightPx / window.innerHeight) * 100;
        
        setBannerHeight(`${totalHeightVh}vh`);
      } else {
        setBannerHeight("35vh");
      }
    }, 100);

    return () => clearTimeout(timer);
  }, [caterogryBanner, expanded]);

  useEffect(() => {
    const scrolling = () => {
      const handleScroll = () => {
        setScroll(window.scrollY > 0);
      };

      window.addEventListener("scroll", handleScroll);

      return () => {
        window.removeEventListener("scroll", handleScroll);
      };
    };

    scrolling();
  }, []);


  
    const rawDescription = caterogryBanner?.bannerDescription ? get_lang(caterogryBanner?.bannerDescription, langValue) : "";
    let description = rawDescription
  .replace(/\n?\s*•\s*/g, "\n• ")  // ensure bullets always start a new line cleanly
  .replace(/\n?\s*-\s*/g, "\n-")  // ensure bullets always start a new line cleanly
  .replace(/\n{2,}/g, "\n")       // remove accidental blank lines
  .trim();

const previewText = description
    

  return isLoading ? (
    <React.Fragment>
      <Skeleton width={250} height={200} />
    </React.Fragment>
  ) : (
    <React.Fragment>
      <Navbar handleGoBack={handleGoBack} />
      <div
        className={`categoryBanner`}
        style={{
          background: `linear-gradient(336deg, rgba(0, 0, 0, 0.67) 0%, rgba(0, 0, 0, 0.19) 100%), 
                        url(${
                          true
                            ? caterogryBanner?.image
                            : `./Rectangle_16965.png`
                        }) center center / cover no-repeat`,
          minHeight: "35vh",
          height: bannerHeight,
          transition: "height 0.3s ease-in-out",
        }}
      >
        <div className="d-flex w-100" >
          <div className={`categoryBanner_content mt-1 w-100`} >
            <div
              className={`d-flex align-items-center mx-3 ${
                langValue === "ar" ? `justify-content-start direction-rtl` : ""
              }`}
            >
              <Avatar variant="rounded" src={bookingInfo?.logo}></Avatar>

              <h5 className="mb-0 px-2 familysora700">
                {get_lang(caterogryBanner?.title, langValue)}
              </h5>
            </div>

            {/* Category Banner Description with "See More" */}
            <h3
              ref={descriptionRef}
              className={`mt-2 familysora600 mx-4 ${langValue === "ar" ? "text-right" : "text-left"}`}
              style={{
                // maxHeight: expanded ? "none" : "120px",
                // overflow: expanded ? "visible" : "hidden",
                maxHeight: "none",
                overflow: "visible",
                transition: "max-height 0.3s ease-in-out",
                paddingRight: "10px",
                whiteSpace: "pre-line",
                lineHeight: "1.8em",
                paddingBottom: '5px'
              }}
            >
              {description}
            </h3>

          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default CategoryBanner;
